import React from "react";

function NotFoundPage() {
  return (
    <div className="page-error" data-testid="page-error">
      <h1>Oops!</h1>
      <p>We could not find the page you were looking for.</p>
    </div>
  );
}

export default NotFoundPage;
